import { de_GetLocationDetailsCommand, se_GetLocationDetailsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetLocationDetailsCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "GetLocationDetails", {})
    .n("SimulationServiceClient", "GetLocationDetailsCommand")
    .f(void 0, void 0)
    .ser(se_GetLocationDetailsCommand)
    .de(de_GetLocationDetailsCommand)
    .build() {
}
